/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'member-right': {
    width: 225.586,
    height: 200,
    viewBox: '0 0 1155 1024',
    data: '<defs/><path pid="0" d="M1137.871 268.71L924.205 24.37A71.222 71.222 0 00870.631 0H287.83a71.222 71.222 0 00-53.364 23.95L18.068 268.5a71.222 71.222 0 00-2.31 91.602l506.327 636.796a71.222 71.222 0 00111.56 0l506.537-637.216a71.222 71.222 0 00-2.31-90.971zM624.611 688.9a60.717 60.717 0 01-93.703 0L259.677 359.05l44.33-36.556 271.231 329.848 275.644-329.218 44.33 36.557z"/>'
  }
})
